import { render, staticRenderFns } from "./select3.vue?vue&type=template&id=c195acf2&scoped=true"
import script from "./select3.vue?vue&type=script&lang=js"
export * from "./select3.vue?vue&type=script&lang=js"
import style0 from "./select3.vue?vue&type=style&index=0&id=c195acf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c195acf2",
  null
  
)

export default component.exports